import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations/translations';

export const FinalCtaSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-blue-900 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-medium mb-6">{t(language, 'sections.startWithStructure')}</h2>
        <p className="text-xl mb-8 text-blue-100">
          {t(language, 'sections.startWithStructureDesc')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/start">
            <Button size="lg" className="shine-cta shine-cta-light w-full sm:w-auto bg-white text-blue-900 hover:bg-gray-100 px-8">
              {t(language, 'nav.startCta')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
